import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Refresh: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.01625 3.64658C3.71262 2.76487 4.79056 2.19999 6.00005 2.19999C8.09873 2.19999 9.80005 3.90131 9.80005 5.99999C9.80005 6.24852 10.0015 6.44999 10.25 6.44999C10.4986 6.44999 10.7 6.24852 10.7 5.99999C10.7 3.40425 8.59579 1.29999 6.00005 1.29999C4.25982 1.29999 2.74107 2.246 1.9291 3.64966C1.86224 3.76524 1.85016 3.90454 1.89613 4.0299C1.94209 4.15526 2.04135 4.25374 2.16708 4.2987L3.48739 4.77092C3.7214 4.85462 3.97896 4.73277 4.06265 4.49875C4.14635 4.26474 4.02449 4.00719 3.79048 3.9235L3.01625 3.64658ZM1.75005 5.54999C1.99858 5.54999 2.20005 5.75146 2.20005 5.99999C2.20005 8.09867 3.90137 9.79999 6.00005 9.79999C7.20953 9.79999 8.28747 9.2351 8.98385 8.35339L8.20961 8.07648C7.9756 7.99278 7.85375 7.73523 7.93744 7.50122C8.02114 7.26721 8.27869 7.14535 8.5127 7.22905L9.83302 7.70127C9.95874 7.74624 10.058 7.84471 10.104 7.97007C10.1499 8.09544 10.1379 8.23474 10.071 8.35031C9.25902 9.75397 7.74028 10.7 6.00005 10.7C3.40431 10.7 1.30005 8.59573 1.30005 5.99999C1.30005 5.75146 1.50152 5.54999 1.75005 5.54999Z"
      />
    </svg>
  )
}

Refresh.displayName = 'Refresh'

export default withIcon(Refresh)
